module.exports = __webpack_public_path__ + "static/media/Nonord-C-Y-A-trial-distration-ta.f5e94a0c.mp3";